import { render, staticRenderFns } from "./Reglementation.vue?vue&type=template&id=7a71f00f&scoped=true&"
import script from "./Reglementation.vue?vue&type=script&lang=js&"
export * from "./Reglementation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a71f00f",
  null
  
)

export default component.exports